import React from 'react';
import styles from './ReportSectionWrapper.module.scss';

export type ReportSectionWrapperProps = {
    children: React.ReactNode;
    className?: string;
};

const ReportSectionWrapper: React.FC<ReportSectionWrapperProps> = ({ children, className = '' }) => {
    return <div className={`${styles.reportSectionRow} ${className}`}>{children}</div>;
};

export default ReportSectionWrapper;
